<div [class.dark-theme]="true" class="fix-action-dialog">
	<mat-dialog-content>
		<ng-container>
			<div style="background: linear-gradient(#242424,#141414);" >
				<h3 data-idtest="aiga-regist-dialog-t-8Ql" mat-dialog-title style="color: #ffffff;">{{ content.title | translate}}</h3>
				<div style="margin:16px;font-size: 14px;">
					<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
						<div fxLayout="column" style="margin-bottom:8px;">
							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;">
									<mat-label><span data-idtest="aigia-regist-dialog-t-5Mq" translate>メールアドレス</span></mat-label>
									<input data-idtest="aigia-regist-dialog-i-4To" #username="ngModel" (blur)="toNickname()" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{'メールアドレス' | translate}}" required type="email" style="color: #ffffff">
									<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスを入力してください</span></mat-error>
									<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
									<mat-error *ngIf="username.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
									<mat-error *ngIf="username.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
								</mat-form-field>
							</div>

							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;">
									<mat-label><span data-idtest="aigia-regist-dialog-t-1Tn" translate>お名前</span></mat-label>
									<input data-idtest="aigia-regist-dialog-i-4Kr" #nickname="ngModel" [(ngModel)]="content.nickname" autocomplete="off" matInput maxlength="100" minlength="3" name="nickname" placeholder="{{'お名前' | translate}}" required type="text" style="color: #ffffff">
									<mat-hint><span data-idtest="aigia-regist-dialog-t-2Py" translate>3文字以上100文字まで</span></mat-hint>
									<mat-error *ngIf="nickname.errors?.['required'];"><span translate>入力してください</span></mat-error>
									<mat-error *ngIf="nickname.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
									<mat-error *ngIf="nickname.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
								</mat-form-field>
							</div>

							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;">
									<mat-label><span data-idtest="aigia-regist-dialog-t-0Zb" translate>パスワード</span></mat-label>
									<input data-idtest="aigia-regist-dialog-i-6Cy" #password="ngModel" [(ngModel)]="content.password" matInput maxlength="1000" minlength="6" name="password" placeholder="{{'パスワード' | translate}}" required type="password" style="color: #ffffff">
									<mat-hint><span data-idtest="aigia-regist-dialog-t-0Ax" translate>6文字以上1000文字まで</span></mat-hint>
									<mat-error *ngIf="password.errors?.['required'];"><span translate>入力してください</span></mat-error>
									<mat-error *ngIf="password.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
									<mat-error *ngIf="password.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
								</mat-form-field>
							</div>

							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;color: #ffffff">
									<mat-label><span data-idtest="aigia-regist-dialog-t-2Vc" translate>パスワード(確認)</span></mat-label>
									<input data-idtest="aigia-regist-dialog-i-8Xf" #confirm_password="ngModel" [(ngModel)]="content.confirm_password" [validateEquals]="password" matInput name="confirm_password" placeholder="{{'パスワード(確認)' | translate }}" required type="password">
									<mat-hint><span data-idtest="aigia-regist-dialog-t-6Yc" translate>6文字以上1000文字まで</span></mat-hint>
									<mat-error *ngIf="confirm_password.errors?.['required'];"><span translate>確認用パスワードを入力してください</span></mat-error>
									<mat-error *ngIf="confirm_password.errors?.['validateEquals']"><span translate>確認用パスワードが一致しません</span></mat-error>
								</mat-form-field>
							</div>

							<div fxLayout="row" fxLayoutAlign="space-between">
								<div class="title-content" fxFlex="100">
									<mat-checkbox (change)="changeAgree($event)" [(ngModel)]="agree" name="agree" aigia-policy-button><a data-idtest="aigia-regist-dialog-t-5Gl" translate>利用規約に同意します</a></mat-checkbox>
								</div>
							</div>

							<ng-container>
								{{completeMessage}}
							</ng-container>
						</div>
					</form>
				</div>
			</div>
		</ng-container>
	</mat-dialog-content>

    <mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" fxLayoutGap="0px" fxLayoutGap.lt-sm="16px" style="padding:16px;">
		<div fxFlex="50" fxFlex.lt-sm="100" fxLayoutAlign="center">
			<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button fxFlex="50" fxFlex.lt-sm="100"><span data-idtest="aigia-regist-dialog-t-5Df" translate>キャンセル</span></button>
		</div>
        <div fxFlex="50" fxFlex.lt-sm="100" fxLayoutAlign="center">
            <button data-idtest="aigia-regist-dialog-b-9Aa" (click)="onAccept()" *ngIf="!(!agree || form.invalid || isProgress)" [disabled]="!agree || form.invalid || isProgress" color="primary" mat-raised-button fxFlex="50" fxFlex.lt-sm="100"><span data-idtest="regist-dialog-t-3Pr" translate>登録</span></button>
			<button data-idtest="aiga-regist-dialog-t-3Pr" *ngIf="(!agree || form.invalid || isProgress)" [disabled]="!agree || form.invalid || isProgress" cdkFocusInitial color="primary" mat-raised-button fxFlex="50" fxFlex.lt-sm="100"><span data-idtest="aigia-regist-dialog-t-0Vy" translate>登録</span></button>
		</div>
	</mat-dialog-actions>
</div>
